import React from "react";
import {
  Input,
  Stack,
  InputGroup,
  InputLeftElement,
  Text,
  Box,
} from "@chakra-ui/core";
import { FaCreditCard, FaPizzaSlice } from "react-icons/fa";
import Logo from "../elements/Logo";
import { FaRegFilePdf } from "react-icons/fa"

const CheckoutFormMockup = () => {
  return (
    <>
      <Stack
        spacing={4}
        borderRadius="5px"
        w="90%"
        m="auto"
        bg="#ffffff"
        p="12px"
      >
        <Stack isInline justifyContent="center" alignItems="center">
          <Box fontSize="32px" color="warning.500" as={FaPizzaSlice} />
          <Text fontWeight="bold" color="warning.500">
            PizzaYolo
          </Text>
        </Stack>
        <Stack
          p="12px"
          bg="primary.transparent-100"
          spacing={1}
          isInline
          fontSize="sm"
          color="primary.500"
        >
          <Box w="35%">
            <Text fontWeight="bold">Order Details</Text>
            <Text fontSize="xs"> 3 large pizzas with pineapple</Text>
          </Box>
          <Box w="25%">
            <Text fontWeight="bold">Total </Text>
            <Text fontSize="xs">33.33 Euros</Text>
          </Box>
          <Box w="30%">
            <Text fontWeight="bold">Invoice </Text>
            <Stack isInline spacing={1}>
            <Text fontSize="xs">
              pizza-yolo-76XL3
            </Text>
            <Box as={FaRegFilePdf} />
            </Stack>
          </Box>
        </Stack>
        <Stack isInline spacing={2}>
          <Input
            isReadOnly={true}
            size="sm"
            name="firstName"
            focusBorderColor="none"
            id="firstName"
            type="text"
            placeholder="Leonardo"
            aria-describedby="Customer first name"
          />
          <Input
            isReadOnly={true}
            size="sm"
            name="lastName"
            focusBorderColor="none"
            id="lastName"
            type="text"
            placeholder="Da Vinci"
            aria-describedby="Customer last name"
          />
        </Stack>
        <Stack borderRadius="3px" borderWidth="1px" p={0} alignItems="center" isInline>
          <Box w="60%">
            <InputGroup size="sm">
              <InputLeftElement
                children={<Box as={FaCreditCard} color="primary.300" />}
              />
              <Input
                isReadOnly={true}
                borderWidth="0px"
                name="credit-card"
                id="card"
                focusBorderColor="none"
                type="number"
                placeholder="Card number"
                aria-describedby="Credit card number field"
              />
            </InputGroup>
          </Box>
          <Box w="20%" borderLeftWidth="1px">
            <Input
              isReadOnly={true}
              borderWidth="0px"
              size="sm"
              name="credit-card"
              focusBorderColor="none"
              type="number"
              placeholder="CVV"
              aria-describedby="Credit card number field"
            />
          </Box>
          <Box borderLeftWidth="1px" w="20%">
            <Input
              isReadOnly={true}
              borderWidth="0px"
              size="sm"
              name="credit-card"
              focusBorderColor="none"
              type="number"
              placeholder="EXP"
              aria-describedby="Credit card number field"
            />
          </Box>
        </Stack>

        <Box
          color="white"
          py="4px"
          w="50%"
          borderRadius="3px"
          textAlign="center"
          bg="success.400"
          m="auto"
          fontWeight="bold"
        >
          Pay 33.33 €
        </Box>
        <Stack
          color="primary.400"
          spacing={0}
          alignItems="center"
          justifyContent="center"
          isInline
        >
          <Box>
            <Text textAlign="center" fontSize="xs">
              Powered by{" "}
            </Text>
          </Box>
          <Box>
            <Logo width="60px" />
          </Box>
        </Stack>
      </Stack>
    </>
  );
};

export default CheckoutFormMockup;
